import { render, staticRenderFns } from "./EditPlagueMonitoring.vue?vue&type=template&id=19693994&scoped=true&lang=html&"
import script from "./EditPlagueMonitoring.vue?vue&type=script&lang=js&"
export * from "./EditPlagueMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19693994",
  null
  
)

export default component.exports